import { Button, Form, Input } from 'antd'
import '../GrammarContent.scss'
import React, { useCallback, useState } from 'react'
import { GetWord } from '../../../../../../../utils'
import Service from '../../../../../../../Service'
import { toast } from 'react-toastify'

const TrueExample = ({ selectData, setIsTrueExample, setIsUpdate }) => {
    const [form] = Form.useForm();
    const [value, setValue] = useState(1);

    const onFinish = useCallback((value) => {
        const service = new Service();
        const entity = {
            description: selectData.description,
            incorrect_sentence: selectData.incorrect_sentence,
            sample_sentece: value.sample_sentece,
            title: selectData.title,
            road_id: selectData.road_id,
        }

        service.AdminService.updateLessonRoadGrammer(entity, selectData.id).then((res) => {
            if (!res.error && res.data) {
                toast.success(GetWord("Added successfully."));
                setIsTrueExample((prev) => !prev);
                setIsUpdate((prev) => !prev);
            } else {
                toast.error(res.message)
            }
        })
    }, [selectData?.description, selectData?.id, selectData?.incorrect_sentence, selectData?.road_id, selectData?.title, setIsTrueExample, setIsUpdate]);

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className='GrammarContent-BodyArea-AddGrammar-Modal'
            initialValues={selectData}
        >
            <Form.Item name="sample_sentece" className='GrammarContent-BodyArea-AddGrammar-Modal-TrueExample' label={<p className='GrammarContent-BodyArea-AddGrammar-Modal-TrueExample-Title'>{GetWord("True Example")}</p>}>
                <Input placeholder={GetWord("Enter a description")} className='GrammarContent-BodyArea-AddGrammar-Modal-TrueExample' />
            </Form.Item>

            <Form.Item className='GrammarContent-BodyArea-AddGrammar-Modal-Button'>
                <Button htmlType='submit' className='GrammarContent-BodyArea-AddGrammar-Modal-Button-Style'>
                    <p className='GrammarContent-BodyArea-AddGrammar-Modal-Button-Text'>{GetWord("Save")}<i className='icon-save GrammarContent-BodyArea-AddGrammar-Modal-Button-Text' /></p>
                </Button>
            </Form.Item>
        </Form>
    )
}

export default TrueExample